import { useState } from 'react';
import { loginBeneficiary } from '../services/api';

export default function Login({ onSuccess, setCurrentPage }) {
  const [form, setForm]       = useState({ email:'', password:'' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email||!form.password) { setError('Please enter your email and password.'); return; }
    setLoading(true); setError('');
    try {
      const data = await loginBeneficiary(form.email, form.password);
      if (data.token) localStorage.setItem('token', data.token);
      const userData = { email:data.email, role:data.role, fullName:data.fullName||data.email.split('@')[0], token:data.token, applicationId:data.applicationId, phone:data.phone };
      localStorage.setItem('userData', JSON.stringify(userData));
      onSuccess(userData);
    } catch(err) { setError(err.message||'Invalid credentials.'); } finally { setLoading(false); }
  };

  return (
    <div style={{ background:'var(--bg-light)', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem' }}>
      <div style={{ background:'white', borderRadius:12, padding:'40px', maxWidth:440, width:'100%', boxShadow:'0 10px 40px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ width:56, height:56, background:'linear-gradient(135deg,var(--primary-color),#0052a3)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontSize:26, color:'white' }}></div>
          <h1 style={{ fontSize:22, fontWeight:700, marginBottom:6 }}>Beneficiary Login</h1>
          <p style={{ color:'var(--text-light)', fontSize:13, margin:0, lineHeight:1.6 }}>Sign in with the credentials emailed to you after approval.</p>
        </div>
        <div style={{ background:'#e0f2fe', border:'1px solid #0284c7', borderRadius:8, padding:'12px 14px', marginBottom:24, display:'flex', gap:10 }}>
          <span></span>
          <p style={{ margin:0, fontSize:12, color:'#0c4a6e', lineHeight:1.65 }}><strong>No self-registration.</strong> Accounts are created only after your application is approved.</p>
        </div>
        {error && <div style={{ background:'#fee2e2', border:'1px solid #fca5a5', borderRadius:8, padding:'10px 14px', marginBottom:18, fontSize:13, color:'#7f1d1d' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, marginBottom:7, textTransform:'uppercase', letterSpacing:'0.5px' }}>Email Address</label>
            <input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="your@email.com" disabled={loading} style={{ width:'100%', padding:'12px 14px', border:'1.5px solid var(--border-light)', borderRadius:8, fontSize:14, boxSizing:'border-box', opacity:loading?0.6:1 }}/>
          </div>
          <div style={{ marginBottom:26 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, marginBottom:7, textTransform:'uppercase', letterSpacing:'0.5px' }}>Password</label>
            <input type="password" value={form.password} onChange={e=>set('password',e.target.value)} placeholder="Your password" disabled={loading} style={{ width:'100%', padding:'12px 14px', border:'1.5px solid var(--border-light)', borderRadius:8, fontSize:14, boxSizing:'border-box', opacity:loading?0.6:1 }}/>
          </div>
          <button type="submit" disabled={loading} style={{ width:'100%', padding:14, background:loading?'var(--text-light)':'linear-gradient(135deg,var(--primary-color),#0052a3)', color:'white', border:'none', borderRadius:8, fontSize:15, fontWeight:600, cursor:loading?'default':'pointer', marginBottom:16 }}>
            {loading?'Signing in...':'Sign In'}
          </button>
        </form>
        <div style={{ borderTop:'1px solid var(--border-light)', paddingTop:20, textAlign:'center' }}>
          <p style={{ color:'var(--text-light)', fontSize:13, margin:'0 0 12px' }}>Haven't applied yet?</p>
          <button onClick={()=>setCurrentPage('apply')} style={{ width:'100%', background:'transparent', color:'var(--primary-color)', border:'1.5px solid var(--primary-color)', padding:11, borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>Submit an Application</button>
        </div>
        <p style={{ textAlign:'center', fontSize:12, color:'var(--text-light)', marginTop:16, marginBottom:0 }}>Forgot credentials? Call <strong>1533</strong></p>
      </div>
    </div>
  );
}




